var render, staticRenderFns
import script from "./FilledButton.vue?vue&type=script&lang=ts&"
export * from "./FilledButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilledButton.vue?vue&type=style&index=0&id=1d3a531a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a531a",
  null
  
)

export default component.exports